"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const caseMixIndex = {
    name: 'case-mix-index',
    altName: 'facility-case-mix-index',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key',
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key',
    ],
};
const ehr = {
    name: 'ehr',
    tableType: 'dim',
    idField: 'ehr_product_chp_id',
    grain: [
        '::id',
        '::key',
    ],
    tableGrain: ['!ehr'],
    foreignKeys: [],
};
const facility = {
    name: 'facility',
    tableType: 'dim',
    grain: [
        '::id',
        '::key',
    ],
    joins: [
        'zip-geo-monthly::key',
        'zcta::key',
        'state::key',
        'county::key',
        'cbsa::key'
    ],
    tableGrain: ['!facility'],
    foreignKeys: [
        'zip-geo::key',
        'zip-geo-monthly::key',
        'zcta::key',
        'state::key',
        'county::key',
        'cbsa::key'
    ],
    facts: [
        '@facility',
        '@hospital',
        '@hospice',
        '@nursing',
        '@hha',
        'hospital-drg-volume-and-charges',
        'hospital-market-share-cbsa',
        'hospital-market-share-county',
        'hospital-market-share-state'
    ]
};
const affiliatedFacility = Object.assign({ ...facility }, { name: 'affiliated-facility' });
const facilityEocByDrgGroup = {
    name: 'facility-episodes-of-care-by-drg-group',
    tableType: 'fact',
    grain: [
        'drg_group',
        'facility::key',
        'year::key',
    ],
    claimsColumns: [
        'count_of_episodes',
    ],
    tableGrain: [
        'drg_group',
        'year_key',
        '!facility',
    ],
    foreignKeys: [
        'facility::key',
    ],
};
const hospital = {
    name: 'hospital',
    tableType: 'dim',
    idField: 'torch_facility_id',
    keyField: 'facility_dim_key',
    grain: [
        'facility::id',
        'facility::key',
    ],
    joins: [
        'zip-geo::key',
    ],
    tableGrain: [
        '!facility',
    ],
    foreignKeys: [
        'zip-geo::key',
    ],
};
exports.default = [
    caseMixIndex,
    ehr,
    facility,
    affiliatedFacility,
    facilityEocByDrgGroup,
    hospital
];
